<script setup>
import SajuInsightYongsinPanelRightJob from './DetailPanelJob.vue';
import DetailPanelDictionary from '@/components/saju-insight/personality/DetailPanelDictionary.vue';
import { DEV_MODE } from '@/config/dev-mode';

const props = defineProps({
  selectedDescNav: {
    type: String,
    default: 'youngsinJob',
  },
});
const emit = defineEmits(['update:selectedDescNav']);

function updateNav(value) {
  emit('update:selectedDescNav', value);
}

const youngsinTabMap = {
  youngsinJob: SajuInsightYongsinPanelRightJob,
  youngsinDictionary: DetailPanelDictionary,
};
const SelectedYoungsinTab = computed(() => youngsinTabMap[props.selectedDescNav]);
</script>
<template>
  <div class="desc-header">
    <div class="desc-nav">
      <button
        :class="['nav-button', { active: selectedDescNav === 'youngsinJob' }]"
        @click="updateNav('youngsinJob')"
      >
        종합분석
      </button>
      <button
        :class="['nav-button', { active: selectedDescNav === 'youngsinDictionary' }]"
        @click="updateNav('youngsinDictionary')"
      >
        용어해석
      </button>
    </div>

    <i class="bot-button"></i>
  </div>

  <div v-if="SelectedYoungsinTab" class="desc-container w-100">
    <div class="inner">
      <div class="main-card youngsin-tab">
        <component :is="SelectedYoungsinTab" />
      </div>
    </div>
  </div>
</template>
